export default __webpack_public_path__ + "static/media/in-transit-blue.f18b0be4.svg";